export default "__VITE_PUBLIC_ASSET__2ca4159b__"